<div
  class="organization-modal modal-content"
  piqetAngularDraggable
  *ngrxLet="myOrganizationFacade.skuYearError$ as error"
>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">{{ modalLabel }} </span>
    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="skuAddEditForm">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label *ngIf="skuAddEditForm.controls['product']?.value" class="sub-header-drpdown pb-2"
              >Project</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #products
              [items]="productList"
              [searchable]="false"
              bindLabel="name"
              formControlName="product"
              [searchFn]=""
              placeholder="Project"
              (change)="selectedScenario($event, 'prod')"
              (clear)="clearDept('prod')"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="products.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (submitted || skuAddEditForm.controls['product']?.touched) &&
                skuAddEditForm.controls['product']?.invalid
              "
              class="input-error"
            >
              Project is required.
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label
              *ngIf="skuAddEditForm.controls['scenario']?.value"
              class="sub-header-drpdown pb-2"
              >Scenario</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              *ngIf="skuAddEditForm.controls['product']?.value"
              #scenarios
              [items]="scenarioList"
              [searchable]="false"
              bindLabel="name"
              formControlName="scenario"
              [searchFn]=""
              bindValue="idLong"
              placeholder="Scenario *"
              class="accordion-text addScroll"
              (clear)="clearDept('scenario')"
              (change)="selectedScenario($event, 'scenario')"
              [virtualScroll]="true"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="scenarios.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
            </ng-select>

            <ng-select
              [clearable]="true"
              *ngIf="!skuAddEditForm.controls['product']?.value"
              [clearOnBackspace]="false"
              groupBy="childItems"
              #scenarios
              [items]="scenarioList"
              [searchable]="false"
              bindLabel="name"
              formControlName="scenario"
              [searchFn]=""
              bindValue="idLong"
              placeholder="Scenario *"
              class="accordion-text addScroll"
              (clear)="clearDept('scenario')"
              (change)="selectedScenario($event, 'scenario')"
              [virtualScroll]="true"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="scenarios.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (submitted || skuAddEditForm.controls['scenario']?.touched) &&
                skuAddEditForm.controls['scenario']?.invalid
              "
              class="input-error"
            >
              Scenario is required.
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="form-group" aria-required="true">
            <label *ngIf="skuAddEditForm.get('UUIDCode')?.value" class="sub-header-drpdown pb-2"
              >UUID</label
            >
            <div class="services-form">
              <input
                formControlName="UUIDCode"
                type="text"
                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                placeholder="UUID"
              />
              <label *ngIf="!skuAddEditForm.get('UUIDCode')?.value">UUID</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="d-flex">
            <div class="d-flex align-items-center">
              <div>
                <p>Internal data</p>
              </div>
              <div class="mb-3">
                <span
                  placement="auto"
                  tooltipClass="sku-tooltip"
                  ngbTooltip="If you have multiple scenarios within a project, then you can add it below."
                >
                  <a class="info-icon">
                    <span>
                      <img
                        src="./assets/icons/grey-question-icon.svg"
                        width="16"
                        height="16" /></span
                  ></a>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label
              *ngIf="
                skuAddEditForm.controls['productDepartment']?.value ||
                skuAddEditForm.controls['productFamily']?.value ||
                skuAddEditForm.controls['productClass']?.value
              "
              class="sub-header-drpdown pb-2"
              >Department</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #department
              [items]="allDepartments"
              [searchable]="false"
              bindLabel="name"
              formControlName="productDepartment"
              placeholder="Department"
              (change)="changeDept($event)"
              (clear)="clearDept()"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="department.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>

        <div class="col-4">
          <div class="form-group required">
            <label
              *ngIf="
                skuAddEditForm.controls['productDepartment']?.value ||
                skuAddEditForm.controls['productFamily']?.value ||
                skuAddEditForm.controls['productClass']?.value
              "
              class="sub-header-drpdown pb-2"
              >Category</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #family
              [items]="categoryListByDeptId"
              [searchable]="false"
              bindLabel="name"
              formControlName="productFamily"
              placeholder="Category *"
              (change)="changeCatg($event)"
              (clear)="clearCatg()"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="family.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (submitted || skuAddEditForm.controls['productFamily']?.touched) &&
                skuAddEditForm.controls['productFamily']?.invalid
              "
              class="input-error"
            >
              Category is required.
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="form-group">
            <label
              *ngIf="
                skuAddEditForm.controls['productDepartment']?.value ||
                skuAddEditForm.controls['productFamily']?.value ||
                skuAddEditForm.controls['productClass']?.value
              "
              class="sub-header-drpdown pb-2"
              >Sub category</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #class
              [items]="subCategoryList"
              [searchable]="false"
              bindLabel="name"
              formControlName="productClass"
              [searchFn]=""
              placeholder="Sub category"
              (change)="changeSubCatg($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="class.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>

      <button #myButton class="hidden-step-trigger"></button>
      <div
        style="width: 20%"
        [ngbPopover]="popContentTwo"
        [autoClose]="false"
        triggers="manual"
        #myPopoverTwo="ngbPopover"
      ></div>
      <div
        class="row"
        [ngbPopover]="popContent"
        [autoClose]="false"
        triggers="manual"
        #myPopover="ngbPopover"
        *ngrxLet="myOrganizationFacade.yearProcessList$ as yearProcessList"
      >
        <piqet-angular-portlet
          [columnDefs]="processColumnDef"
          [frameworkComponents]="frameworkComponents"
          [error]="error"
          (editDataEvent)="checkValidation(error)"
          [gridData]="yearProcessList"
          [hidePagination]="true"
          [hideSearch]="true"
          [headerBtn]="'Add row'"
          [gridName]="'addSKUdata'"
          [headerBtnName]="'skuYearProcess'"
          [disableButton]="disableSubmit || isRowEditable"
          [showErrorInAccordian]="true"
          [isSetWidth]="true"
          [class]="'overflowCheck'"
          [isInlineGrid]="true"
        >
        </piqet-angular-portlet>
      </div>
    </form>
  </div>

  <div
    class="modal-footer text-margin"
    *ngrxLet="myOrganizationFacade.yearProcessList$ as yearProcessList"
  >
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button
      type="button"
      class="modelBtn purpleBtnHoverEffect"
      [disabled]="disableSubmit || isRowEditable"
      (click)="onSave(yearProcessList)"
    >
      Save
    </button>
  </div>
</div>

<ng-template #popContent>
  <div class="d-flex justify-content-end pb-3">
    <button type="button" class="closePopover" aria-label="Close" (click)="closeAllSteps('one')">
      <img src="./assets/icons/pop-up-cross.svg" width="12" height="13" />
    </button>
  </div>
  <p class="modal-tour-text">
    If you have multiple scenarios within a project, then you can add it below.
  </p>
  <div class="d-flex justify-content-between">
    <div class="step-counter d-flex align-items-center">1/2</div>
    <button class="modal-tour-btn" (click)="closePopup('one')">NEXT</button>
  </div>
</ng-template>

<ng-template #popContentTwo>
  <div class="d-flex justify-content-end pb-3">
    <button type="button" class="closePopover" aria-label="Close" (click)="closeAllSteps('two')">
      <img src="./assets/icons/pop-up-cross.svg" width="12" height="13" />
    </button>
  </div>
  <p class="modal-tour-text">Add the number of UUID units produced in a year.</p>
  <div class="d-flex justify-content-between">
    <div class="d-flex align-items-center">
      <div class="step-counter d-flex align-items-center">2/2</div>
    </div>
    <div>
      <button class="modal-tour-prev-btn" (click)="goBack()">PREV</button>
      <button class="modal-tour-btn" (click)="closePopup()">DONE</button>
    </div>
  </div>
</ng-template>
